import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function isPortraitMobile() {
  // Uniquement sur les écrans ≤ 1024px (mobile/tablette)
  return window.innerWidth <= 1024 && window.innerHeight > window.innerWidth;
}

// Routes où l'avertissement ne doit pas s'afficher (accessibles en portrait)
const PORTRAIT_ALLOWED_ROUTES = ['/login', '/first-login'];

export default function OrientationWarning() {
  const location = useLocation();
  const [isPortrait, setIsPortrait] = useState(isPortraitMobile());
  const [dismissed, setDismissed] = useState(false);
  const isAllowedRoute = PORTRAIT_ALLOWED_ROUTES.includes(location.pathname);

  useEffect(() => {
    const update = () => setIsPortrait(isPortraitMobile());
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  // Ré-armer l'avertissement seulement quand l'utilisateur quitte réellement le
  // portrait, pour qu'il puisse se redéclencher à la prochaine rotation — sans
  // annuler le clic sur "Continuer quand même" tant qu'on reste en portrait.
  useEffect(() => {
    if (!isPortrait) setDismissed(false);
  }, [isPortrait]);

  const show = isPortrait && !dismissed;

  if (!show || isAllowedRoute) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      zIndex: 9999,
      backgroundColor: 'rgba(15, 23, 42, 0.93)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      textAlign: 'center',
    }}>
      {/* Icône rotation */}
      <div style={{
        marginBottom: '24px',
        animation: 'rotateHint 2s ease-in-out infinite',
      }}>
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Téléphone en portrait */}
          <rect x="26" y="8" width="28" height="46" rx="4" fill="#334155" stroke="#60a5fa" strokeWidth="2"/>
          <circle cx="40" cy="50" r="2.5" fill="#60a5fa"/>
          {/* Flèche rotation */}
          <path
            d="M60 28 C68 36, 68 52, 56 60"
            stroke="#60a5fa"
            strokeWidth="2.5"
            strokeLinecap="round"
            fill="none"
          />
          <polyline
            points="52,56 57,62 63,57"
            stroke="#60a5fa"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      </div>

      <h2 style={{
        color: '#f1f5f9',
        fontSize: '20px',
        fontWeight: '700',
        marginBottom: '12px',
        lineHeight: '1.3',
      }}>
        Tourne ton écran en mode paysage
      </h2>

      <p style={{
        color: '#94a3b8',
        fontSize: '15px',
        marginBottom: '32px',
        lineHeight: '1.5',
        maxWidth: '280px',
      }}>
        L'application est conçue pour être utilisée à l'horizontale. Tu auras une bien meilleure expérience !
      </p>

      <button
        onClick={() => setDismissed(true)}
        style={{
          background: 'transparent',
          border: '1px solid #475569',
          borderRadius: '8px',
          color: '#64748b',
          fontSize: '13px',
          padding: '8px 16px',
          cursor: 'pointer',
        }}
      >
        Continuer quand même en portrait
      </button>

      <style>{`
        @keyframes rotateHint {
          0%, 100% { transform: rotate(0deg); }
          40% { transform: rotate(90deg); }
          60% { transform: rotate(90deg); }
        }
      `}</style>
    </div>
  );
}
